import { useState, useEffect } from 'react';
import { read_cookie } from "sfcookies";
import { hostUrl, UseUrlManagerCleanUrl } from "../utils/url-manager";

export const useGetEmailCountForNok = (nokUrl: string) => {
    const [newEmailCount, setNewEmailCount] = useState<number>(0);
    const [isLoading, setIsLoading] = useState(false);

    function getNewEmailCount(): void {
        if (nokUrl.includes('https')) {
            nokUrl = nokUrl.replace('https://', '');
        }
        if (nokUrl.endsWith('http')) {
            nokUrl = nokUrl.replace('http://', '');
        }

        let url: string = hostUrl + 'hq/nok/email/new/count?url=' + nokUrl;
        url = UseUrlManagerCleanUrl({ url: url });
        const token: string = read_cookie('auth');
        const request: Request = new Request(url, {
            method: 'GET',
            headers: new Headers({
                'Content-Type' : 'application/json',
                'token' : token
            })
        });
        fetch(request)
            .then( (response: Response) => {
                return response.json();
            })
            .then( (data: any) => {
                setIsLoading(false);
                if (data !== undefined && data['message'] === 'success') {
                    setNewEmailCount(data['count']);
                }
            } )
            .catch( (error: Error) => {
                console.log(error);
            } );
    }

    function reloadNewCount(): void {
        setIsLoading(true);
        getNewEmailCount();
    }

    getNewEmailCount();

    return { newEmailCount, isLoading, reloadNewCount };
}